import React from 'react';
import './Datenschutz.css';

const Datenschutz = () => {
  return (
    <div className="datenschutz-container">
      <div className="datenschutz-content">
        <h1>Datenschutzerklärung</h1>

        <section className="datenschutz-section">
          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website
            besuchen oder unsere Dienstleistungen in Anspruch nehmen. Personenbezogene
            Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>
        </section>

        <section className="datenschutz-section">
          <h2>2. Verantwortlicher</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website und im Rahmen unserer Umzugsdienstleistungen ist:
          </p>
          <div className="company-details">
            <p><strong>Save Move</strong></p>
            <p>Inhaber: Hasan Al Mohamad</p>
            <p>Am Sandhaus 31</p>
            <p>13125 Berlin</p>
            <p>Deutschland</p>
            <p>E-Mail: <a href="mailto:info@savemove.de">info@savemove.de</a></p>
            <p>Telefon: <a href="tel:+4917684572071">+49 176 845 720 71</a></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>3. Datenerfassung bei Anfragen & Umzugsplanung</h2>
          <p>
            Wir verarbeiten Ihre personenbezogenen Daten, um Umzugsangebote zu erstellen, Aufträge auszuführen und die Abrechnung abzuwickeln (Art. 6 Abs. 1 lit. b DSGVO).
          </p>
          <p>Dazu gehören insbesondere:</p>
          <ul>
            <li><strong>Kontaktdaten:</strong> Name, Telefonnummer, E-Mail-Adresse.</li>
            <li><strong>Adress- und Standortdaten:</strong> Bisherige und neue Adresse, Stockwerk, Aufzugsverfügbarkeit, Laufwege, Haltemöglichkeiten.</li>
            <li><strong>Auftrags- und Inventardaten:</strong> Liste des Umzugsguts (inkl. Sondergegenstände wie Klavier oder Tresor), Demontage-/Montagewünsche, Verpackungsservice.</li>
            <li><strong>Abrechnungsdaten:</strong> Bankverbindung, Rechnungsadresse, Zahlungshistorie.</li>
          </ul>
        </section>

        <section className="datenschutz-section">
          <h2>4. Weitergabe von Daten an Dritte</h2>
          <p>
            Eine Übermittlung Ihrer Daten an Dritte erfolgt ausschließlich zur Vertragserfüllung oder bei gesetzlicher Verpflichtung (Art. 6 Abs. 1 lit. b und c DSGVO):
          </p>
          <ul>
            <li><strong>Behörden:</strong> Zur Beantragung von Halteverbotszonen bei den zuständigen Straßenverkehrsbehörden.</li>
            <li><strong>Versicherungen:</strong> Im Falle der Schadenabwicklung (Transport- und Haftpflichtversicherung).</li>
            <li><strong>Dienstleister:</strong> Steuerberater, IT-Hoster und Zahlungsdienstleister.</li>
          </ul>
        </section>

        <section className="datenschutz-section">
          <h2>5. Datenerfassung auf unserer Website</h2>
          <p>
            <strong>Server-Log-Files:</strong> Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt (IP-Adresse, Dateiaufrufe, Browser-Typ, Uhrzeit der Anfrage) gemäß Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p>
            <strong>Kontaktformular:</strong> Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          </p>
        </section>

        <section className="datenschutz-section">
          <h2>6. Speicherdauer</h2>
          <p>
            Wir speichern Ihre Daten nur so lange, wie es für die Abwicklung des Auftrags oder aufgrund gesetzlicher Aufbewahrungsfristen (z. B. steuer- und handelsrechtliche Vorgaben von bis zu 10 Jahren) erforderlich ist. Anschließend werden die Daten gelöscht.
          </p>
        </section>

        <section className="datenschutz-section">
          <h2>7. Ihre Rechte</h2>
          <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:</p>
          <ul>
            <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
            <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
            <li>Einschränkung der Datenverarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          </ul>
          <p>
            Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Datenschutz-Aufsichtsbehörde zu.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Datenschutz;